import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "aepbutton"
    }}>{`AEPButton`}</h1>
    <p>{`The AEPButton class is a fundamental UI component used to create interactive buttons for content cards.`}</p>
    <p>{`Customization of the button's properties can be achieved with a custom view modifier.`}</p>
    <p>{`AEPButton conforms to `}<inlineCode parentName="p">{`ObservableObject`}</inlineCode>{`, allowing it to be used reactively in SwiftUI views.`}</p>
    <h2 {...{
      "id": "public-properties"
    }}>{`Public Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "aeptext.md"
            }}>{`AEPText`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The text model representing the button's label.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`modifier`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`AEPViewModifier`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A custom view modifier that can be applied to the button view for additional styling.`}</td>
        </tr>
      </tbody>
    </table>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`All properties are marked with `}<a parentName="p" {...{
        "href": "https://developer.apple.com/documentation/combine/published"
      }}>{`@Published`}</a>{`. Any changes will trigger updates to the UI.`}</p>
    <h2 {...{
      "id": "customization"
    }}>{`Customization`}</h2>
    <p>{`You can customize the `}<inlineCode parentName="p">{`AEPButton`}</inlineCode>{` properties when working with a template that includes a button. Here's an example:`}</p>
    <CodeBlock slots="heading, code" repeat="1" languages="Swift" mdxType="CodeBlock" />
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`class MyCustomizer: ContentCardCustomizing {
    func customize(template: SmallImageTemplate) {
        // Customize the button element
        template.buttons?.first?.text.font = .headline
        template.buttons?.first?.text.textColor = .white
        template.buttons?.first?.modifier = AEPViewModifier(MyButtonModifier())
    }
    
    struct MyButtonModifier: ViewModifier {
        func body(content: Content) -> some View {
            content
                .padding()
                .background(Color.blue)
                .cornerRadius(10)
        }
    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      